<template>
    <div class="employee-tab-inner">
        <div class="row no-gutters py-2 mb-3 border-bottom mt-3">
            <div class="col-sm-6 px-3 company-form-box-title">Rent Free Accommodation</div>
            <template  v-if="$acl['employee/rfa'] == 2"><div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"  @click="addNew()"><button class="btn btn-block btn-secondary tab-button"> Add Rent Free Accommodation </button></div></template>
        </div>
        
        <b-overlay :show="showoverlay_list" rounded="sm" class="card no-shadow">
            <div class="mx-2 p-4">    
                                                            
                <div class="row border-bottom table-head">
                    <div class="col-sm py-1 font-weight-bold align-self-center">
                        Fiscal Year
                    </div>
                    <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                        Month
                    </div>                    
                    <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                        Amount
                    </div>
                    <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                        Last Activity
                        <span class="custom-date-indicator">(YYYY-MM-DD)</span>
                    </div>
                    <div class="col-sm py-1 font-weight-bold text-right align-self-center" v-if="$acl['employee/rfa'] == 2">    
                        Action                                
                    </div>
                </div>
            
                <div class="row hover-bg table-row border-bottom py-2" v-for="rfc in rfcs" :key="rfc.id">
                    <div class="col-sm">                    
                        <div class="text-uppercase ">{{rfc.fiscal_year}}</div>
                    </div>
                    <div class="col-sm">                    
                        <div class="text-center ">
                            <template v-for="mnr in months">
                                <template v-if="mnr.value == rfc.month">{{mnr.text}}</template>
                            </template>
                        </div>
                    </div>
                    <div class="col-sm text-right">
                        <template v-if="decimal_setting == 'no'">{{moneyFormat(Math.round(rfc.amount))}}</template><template v-else>{{moneyFormat(rfc.amount)}}</template>
                    </div>
                    <div class="col-sm  text-center">
                        <template v-if="rfc.updated_at != null">{{ formatMe(rfc.updated_at) }}</template>
                        <template v-else>{{ formatMe(rfc.created_at) }}</template>
                    </div>
                    <div class="col-sm text-right clearfix" v-if="$acl['employee/rfa'] == 2">                                
                        <b-button-toolbar class="position-relative text-right justify-content-end" v-if="rfc.flg == 1">
                             <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                             <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                <b-button-group class="mr-1">
                                    <b-button title="Edit RFC" @click="editRfc(rfc.id)">
                                        <i class="fa fa-pencil-alt"></i> Edit
                                    </b-button>
                                    <b-button title="Delete RFC" @click="deleteRfc(rfc.id)">
                                        <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                    </b-button>
                             
                                </b-button-group>
                             </div>
                        </b-button-toolbar>
                        <div class="text-center float-right" v-else title="This entry can't be edited or deleted since a payrun has been approved after this was listed." v-b-tooltip placement="right">
                            <b-icon icon="info-circle"></b-icon>
                        </div>
                    </div>

                </div>                        
            </div>
        </b-overlay>

        <b-modal id="bv-modal-example" size="lg" hide-footer title="Add Rent Free Accommodation">
            <b-form @submit.stop.prevent="onSubmit">                    
                <div class="clearfix">

                    <div class="col-md-12 float-left">                           
                        
                        <input type="hidden" v-model="fdata.id" name="id">
                        <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field" label-for="fiscal_year">
                            <!--<b-form-input id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" readonly></b-form-input>-->
                            <b-form-select id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" :options="fiscal_years"></b-form-select>
                        </b-form-group>


                        <b-form-group id="month-group" label="Month" label-for="month">
                            <b-form-select id="month" name="month" v-model="fdata.month" :options="months" ></b-form-select>                                    
                        </b-form-group>
                        
                        <b-form-group id="amount-group" label="Amount" class="required-field" label-for="amount">
                            <b-form-input id="amount" name="amount" v-model="fdata.amount" v-validate="{ required: true, min: 3 }" :state="validateState('amount')" aria-describedby="amount-feedback" data-vv-as="Amount"></b-form-input>
                            <b-form-invalid-feedback id="amount-feedback">{{ veeErrors.first('amount') }}</b-form-invalid-feedback>
                        </b-form-group>                                
                    </div>                            
                </div>

                <div class="mt-4 ml-4 mb-4 clearfix" style="margin-right: 18px;">
                    <b-button class="border rounded float-right py-1 px-5 mt-4 ml-2" type="submit" variant="success">Submit</b-button>
                    <b-button class="border rounded float-right py-1 px-5 mt-4 ml-2" variant="success" @click="resetForm()">Reset</b-button>
                </div>

            </b-form>
        </b-modal>

    </div>
    
</template>
<script>
    import moment from 'moment';

    export default{
        
        mounted() {
            
            //console.log(this.employee_id);  
        },
        props: ['flg'],
        data(){            
            
            return {                
                itabIndex : 0,
                fiscal_year : this.getCurrentFinancialYear(),
                months: [{ value: 1, text: "January" },{ value: 2, text: "February"},{ value: 3, text: "March"},{ value: 4, text: "April"},{ value: 5, text: "May"},{ value: 6, text: "June"},{ value: 7, text: "July"},{ value: 8, text: "August"},{ value: 9, text: "September"},{ value: 10, text: "October"},{ value: 11, text: "November"},{ value: 12, text: "December", } ],

                rfcs : [], 
                      
                successmsg:null,
                errormsg:[],
                fdata: {fiscal_year : this.getCurrentFinancialYear(), month:1, amount:null, id:null },

                fiscal_years: [                    
                    { value: "2021-2022", text: "2021-2022" },
                    { value: "2020-2021", text: "2020-2021" },
                ], 
                
                decimal_setting: 'yes',                     
                
            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('YYYY-MM-DD hh:mm:ss A');
            },
            moneyFormat(amount)
            {
                var money = Number(amount);
                money = money.toLocaleString();
                if(this.decimal_setting == 'yes' || this.decimal_setting == '')
                    if(money.indexOf(".")<0)
                        money = money+'.00';
                return money;
            },
            getRfcs: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
               
                axios.get(this.$api_url+'/rfc/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.rfcs = response.data;
                    this.tabIndex = 1;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },   
            editRfc:function(x)
            {        
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/rfc/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.successmsg = null;
                    this.$bvModal.show('bv-modal-example');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                                
            },           
            
            deleteRfc:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this RFC.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {                    
                    if(value)
                    {                        
                        this.resetForm();
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);
                        
                        axios.post(this.$api_url+'/rfc/delete', formData).then(function(response){
                            
                            if(response.data.status == true)
                            {
                                this.successmsg = response.data.meg; 
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                this.getRfcs();                    
                            }
                            this.showoverlay_list = false;                            
                            
                        }.bind(this)).catch(function (error){ currentObj.showoverlay_list = false; currentObj.serverError(error);});   
                    }
                })
            }, 
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
               this.fdata = {fiscal_year: this.getCurrentFinancialYear() , amount:null, id:null};
                
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNew()
            {
                this.resetForm();    
                this.$bvModal.show('bv-modal-example');            
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        //headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();
                                        
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    axios.post(this.$api_url+'/rfc/save', formData, config)
                        .then(function (response) 
                        {                                                              
                            this.resetForm();
                            this.getRfcs();
                            this.itabIndex = 1;                              

                            this.$bvToast.toast("Saved", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                            this.$bvModal.hide('bv-modal-example');
                            
                        }.bind(this))
                        .catch(function (error) 
                        {
                            currentObj.serverError(error);
                            //currentObj.errormsg = error.response.data.errors;
                        });
                });
            },
            get_decimal_settings: function()
            {
              axios.get(this.$api_url+'/decimal-settings')
            
              .then(function (response) {  
                this.decimal_setting = response.data;  
              }.bind(this));
            },

        },
        created: function(){
            this.getRfcs();
            this.get_decimal_settings();
        }
    }
</script>
